import { render } from "./Hcaptcha.vue?vue&type=template&id=84abc63a&scoped=true"
import script from "./Hcaptcha.vue?vue&type=script&lang=js"
export * from "./Hcaptcha.vue?vue&type=script&lang=js"

import "./Hcaptcha.vue?vue&type=style&index=0&id=84abc63a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_nnqy633ba33w3ap4lrqhdb3em4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84abc63a"]])

export default __exports__